import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row align-self-center" }
const _hoisted_2 = { class: "d-flex align-self-center" }
const _hoisted_3 = { style: {"line-height":"1","text-align":"center"} }
const _hoisted_4 = { class: "progress-value" }
const _hoisted_5 = { class: "ms-4 d-flex align-self-center flex-column" }

import { ref } from 'vue'
import { checkMobile } from '../../utils/utils'
import ChartProgress from './ChartProgress.vue'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardProgress',
  props: {
    progressRate: {}
  },
  setup(__props: any) {

const props = __props

// Reactive Data
const mobile = ref(checkMobile())

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_progress_circular, {
        size: 150,
        width: 20,
        "model-value": __props.progressRate,
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.progressRate), 1 /* TEXT */),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "progress-percent" }, "%", -1 /* CACHED */))
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})